import { useMediaQueryContext } from 'contexts/MediaQueryContext'

export type MapMode = 'inline' | 'toggle'

const useWhichMapMode = (): MapMode => {
  const { xl } = useMediaQueryContext()

  return xl ? 'inline' : 'toggle'
}

export default useWhichMapMode
